import React from "react";
import { MegaMenu } from "primereact/megamenu";
import "./style.scss";
import { useNavigate } from "react-router-dom";
import { getMenuItems } from "./MegaMenuItems";
import Logo from "../../assets/images/logo.png";
import { Link } from "react-router-dom";
import { APPLICATION_OPEN_DATE, APPLICATION_CLOSE_DATE, APPLICATION_OPEN_DATE_DISPLAY } from "../../constants";

const Header = () => {
  const navigate = useNavigate();
  const menuItems = getMenuItems(navigate);

  const today = new Date();
  const applicationOpenDate = APPLICATION_OPEN_DATE;
  const applicationCloseDate = APPLICATION_CLOSE_DATE;

  const scrollingText = (today < applicationOpenDate) ? `Admissions open ${APPLICATION_OPEN_DATE_DISPLAY}.` : 'Admissions for 2026 are now open. APPLY NOW!'
  const applyButtonText = (today < applicationOpenDate) ? 'How to Apply' : 'Apply Now'

  return (
    <>
      {/* Section: Upper Header */}
      {today <= applicationCloseDate && <section className="su-header--upper">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="su-header--upperlist">
                <li key="scrolling" className="scrolling-container">
                  <div className="scrolling-text">
                    {scrollingText}
                  </div>
                </li>
                <li key="apply" className="apply-now">
                  {today < applicationOpenDate ? (
                    <Link to={'/admissions'} className="active">{applyButtonText}</Link>
                  ) : (
                    <a href="https://admissions.sitare.org/" className="active" target="_blank" rel="noopener noreferrer">{applyButtonText}</a>
                  )}
                </li>
                <li key="learn-more" className="apply-now">
                  <Link to={'/admissions'} className="active">Learn More</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>}
      {/* Section: Upper Header End */}

      {/* Section: Header Menu */}
      <section className="su-header--menu ">
        <div className="container px-md-0 px-md-3">
          <div className="row align-items-center">
            <div className="col-md-2 col-6">
              <div className="logo_header">
                <Link to={"/"}>
                  <img src={Logo} alt="logo" draggable="false" />
                </Link>
              </div>
            </div>
            <div className="col-md-10 col-6">

              <MegaMenu
                model={menuItems}
                breakpoint="992px"
                className="w-100"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Section: Header Menu End*/}
    </>
  );
};

export default Header;
